import { EXTERNAL_PATHS } from 'src/common/constants';
import { completePriceFormatter } from 'src/common/utils/currency';
import type { PaymentAddonProps } from 'src/inbox/components/PaymentAddon';
import type PaymentAddon from 'src/inbox/components/PaymentAddon';

/**
 * The `PaymentAddon` component expects addons transformed to this props shape.
 * This was originally handled in the `PaymentAddons` component function body. However,
 * PaymentAddons also applied a root div and styles that some callers did not need.
 * This helper shares the transform logic for use outside of `PaymentAddons`.
 */
const formatPaymentAddons = ({
  addon,
  isOwner,
}:{
  addon: PaymentAddon;
  isOwner: boolean;
}): PaymentAddonProps => {
  const amounts = addon.transaction?.amounts;
  const description = amounts?.description ?? addon.description;
  const formattedAmount = isOwner ? completePriceFormatter(
    amounts.subtotal,
    amounts.owner_currency.code,
    amounts.owner_currency.symbol,
  ) : addon.formatted_renter_subtotal as string;
  const subTypeLabel = amounts?.sub_type_label ?? addon.sub_type_label;
  const paymentCategory = `${subTypeLabel}${description ? `: ${description}` : ''}`;
  const summaryLink = isOwner
    ? `${EXTERNAL_PATHS.CHARGE_ADD_ON}summary/${addon.thread}/${addon.pk}/`
    : undefined;
  const paymentLink = `${EXTERNAL_PATHS.CHARGE_ADD_ON}${addon.thread}/${addon.hash_id}/`;

  return {
    expiryDate: addon.expiry_date_UTC,
    lastActivityDate: addon.status_date_UTC,
    paymentAmount: formattedAmount,
    paymentCategory,
    summaryLink,
    paymentLink,
    status: addon.status,
    userRole: isOwner ? 'owner' : 'renter',
  };
};

export default formatPaymentAddons;
